/**
 * Выгрузка расчёта в CSV.
 *
 * Прямой ссылкой файл не забрать: эндпоинт требует заголовок авторизации
 * Telegram, а тег <a> его не отправит. Поэтому качаем запросом, превращаем
 * в Blob и отдаём браузеру.
 *
 * В некоторых WebView Telegram скачивание блокируется — тогда честно
 * говорим об этом вместо тихого «ничего не произошло».
 */

import { ApiError } from '@/shared/api/client'
import { getInitData } from '@/shared/telegram'

export async function downloadTimesheetCsv(
  timesheetId: number,
  fileName: string,
): Promise<void> {
  const response = await fetch(`/api/timesheets/${timesheetId}/export.csv`, {
    headers: { Authorization: `tma ${getInitData()}` },
  })

  if (!response.ok) {
    throw new ApiError(response.status, {
      code: 'export_failed',
      message: 'Не удалось выгрузить расчёт',
    })
  }

  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.append(link)
    link.click()
    link.remove()
  } finally {
    // Освобождаем ссылку не сразу: Safari успевает начать загрузку.
    setTimeout(() => URL.revokeObjectURL(url), 10_000)
  }
}
